import { render, staticRenderFns } from "./posted-transactions.components.vue?vue&type=template&id=4924e026&"
import script from "./posted-transactions.components.vue?vue&type=script&lang=ts&"
export * from "./posted-transactions.components.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports